"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the Apache License. See License in the project root for license information.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Describes the default operation timeout in seconds. Value: `60`.
 */
exports.defaultOperationTimeoutInSeconds = 60;
//# sourceMappingURL=constants.js.map